import { useNavigate } from 'react-router-dom';
// Material-UI imports
// MSAL imports
import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { ApiAuthProvider } from './auth/ApiAuthProvider';
import { ApiSession } from './auth/apiSession';
// Sample app imports
import UnAuthenticatedRedirect from './layouts/auth/UnAuthenticatedRedirect';
import { CustomNavigationClient } from './utils/NavigationClient';
import RouterV2 from './RouterV2';

import 'react-quill/dist/quill.snow.css';
import 'simplebar-react/dist/simplebar.min.css';

type AppProps = {
  pca: IPublicClientApplication;
  apiSession: ApiSession;
};

function App({ pca, apiSession }: AppProps) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <ApiAuthProvider session={apiSession}>
        <UnAuthenticatedRedirect>
          <RouterV2 />
        </UnAuthenticatedRedirect>
      </ApiAuthProvider>
    </MsalProvider>
  );
}

export default App;
